{
  "title": "Approval Matrix",
  "subtitle": "Configure multi-level approval workflows for enterprise transactions.",
  "transactionType": "Transaction Type",
  "threshold": "Threshold Condition (Total Value >)",
  "hierarchyMode": "Approval Hierarchy Mode",
  "sequential": "Sequential",
  "anyOne": "Any-One",
  "levels": "Approval Levels",
  "addLevel": "Add Approval Level",
  "level": "Level",
  "approverType": "Approver Type",
  "approverRole": "Role",
  "approverUser": "User",
  "selectRole": "Select Role",
  "selectUser": "Select User",
  "removeLevel": "Remove",
  "saveMatrix": "Save Matrix",
  "activeToggle": "Active",
  "autoNotify": "Auto-Notify",
  "slaHours": "SLA Deadline (hours)",
  "flowPreview": "Visual Flow Preview",
  "summary": "Quick Summary",
  "totalLevels": "Total Levels",
  "noLevels": "No approval levels configured yet — add at least one.",
  "authorized": "Authorized"
}
